import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/16/thumb-landscape.jpg"

const Post16 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">GUCCI／GGマーモント／24 x15 x6cm</span>     
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          今、最もホットなブランドといえば、GUCCI（グッチ）です。<br></br>2015-16AWよりデザイナーがアレッサンドロ・ミケーレになりました。以前のグラマラスでセクシーなグッチの印象をガラリと変え、よりフレッシュでストリート色を前面に打ち出したコレクションは、グッチ史上最もストリート色の強いリアルクローズを作り上げました。これまでのイメージを打ち崩して生まれ変わろうとしている、まさに今がターニングポイント！<br></br>この瞬間を見逃すまいと、世界中のセレブやファッショニスタが注目しています。あなたもグッチのバッグを持って、街を颯爽と歩きませんか？<br></br>ラクサスでも愛用ユーザー多数のグッチ。大人気バッグ10選をご紹介します！
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>ホースビット</h2>
          <p>ブランドの代表的モデル「ホースビット」の登場は1950年代。馬に噛ませる轡（くつわ）がモチーフのもとになっており、グッチと縁が深い乗馬の世界観を反映したアイテムです。高級感のある金具はどんなスタイルにもマッチし、年代を問わず高い人気を誇ります。バッグだけでなくアクセサリーや靴まで幅広く展開されています。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/1.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/16/2.jpg" alt="" />
            </figure>        
        </div>
        <span className="text-center">GUCCI／ホースビット／22 x18 x8cm</span>  
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/3.jpg" alt="" />
            <span className="text-center">GUCCI／バケットバッグ／22 x13 x12cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/4.jpg" alt="" />
            <span className="text-center">GUCCI／ホースビット／33 x23 x14cm</span> 
          </figure>          
        </div>
        <div className="text-max-width">
          <h2>シルヴィ</h2>
          <p>ゴールドの金具と「シェリーライン(赤と緑のライン)」の組み合わせが高級感あふれる「シルヴィ」。ストラップはレザータイプとリボンタイプの2本が付属。普段のお出かけにはもちろん、パーティーシーンにもぴったりハマるアイテムです。</p>
        </div>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/5.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/6.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">GUCCI／シルヴィ／25 x16 x8cm</span>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/7.jpg" alt="" />
            <span className="text-center">GUCCI／シルヴィ／30 x19 x10cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/8.jpg" alt="" />
            <span className="text-center">GUCCI／シルヴィ／27 x19 x11cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ダイアナ</h2>
          <p>2021年の6月にデビューした「ダイアナ」。1947年に誕生した「バンブーハンドル」をクリエイティブ・ディレクターのアレッサンドロ・ミケーレが現代的に再解釈したモデルです。ハンドルにあしらわれたレザーベルトも当時のバッグに付属していた収納用バンドからアイデアを得たものだそう。クラシカルでありながら斬新なデザインは、GUCCIの新たなアイコンバッグになること間違いなし。</p>
        </div>       
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/9.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/10.jpg" alt="" />
          </figure>
        </div>    
        <span className="text-center">GUCCI／ダイアナスモール／27 x23 x10cm</span>       
        <div className="text-max-width">
          <h2>ソーホー</h2>
          <p>エンボス加工されたGGロゴが特徴の「ソーホー」。2012年にフリーダ・ジャンニーニのクルーズコレクションで発表されて以来、グッチの定番スタイルとして人気を博しています。最高級のソフトカーフレザーを使用しており、柔らかくくたっとした手触りが上質感あふれるアイテム。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/13.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/14.jpg" alt="" />
          </figure>
        </div>          
        <span className="text-center">GUCCI／ソーホー／35 x29 x17cm</span>   
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/15.jpg" alt="" />
            <span className="text-center">GUCCI／ソーホー／19 x14 x6cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/16.jpg" alt="" />
            <span className="text-center">GUCCI／ソーホー／28 x19 x8cm</span> 
          </figure>
        </div>    
        <Link to="https://laxus.co/app/pc/bags/gucci" className="view-all-button">
          グッチのバッグを見る
        </Link>         
        <div className="text-max-width">
          <h2>GGマーモント</h2>
          <p>「GGマーモント」はグッチが70年代にベルトのバックルとして使用していたデザインから着想を得たもの。バッグに留まらず財布やキーケースなどグッチの様々なアイテムに用いられています。スポーティーなコーデとも好相性◎。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/17.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/18.jpg" alt="" />
          </figure>
        </div> 
        <span className="text-center">GUCCI／GGマーモント／18 x11 x6cm</span>   
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/19.jpg" alt="" />
            <span className="text-center">GUCCI／GGマーモント／21 x13 x6cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/20.jpg" alt="" />
            <span className="text-center">GUCCI／GGマーモント／26 x19 x7cm</span> 
          </figure>
        </div>     
        <div className="text-max-width">
        <h2>GGブルームス</h2>
        <p>GGブルームスはフラワープリントがコーデに華やかさを与えてくれます。シンプルなコーデもリッチにレディに仕上げてくれます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/21.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/22.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">GUCCI／GGブルームス／22 x17 x9cm</span>   
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/23.jpg" alt="" />
            <span className="text-center">GUCCI／GGブルームス／34 x37 x10cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/24.jpg" alt="" />
            <span className="text-center">GUCCI／リバーシブル／37 x27 x11cm</span> 
          </figure>
        </div>   
        <div className="text-max-width">
          <h2>オフィディア</h2>
          <p>2018年のコレクションで発表され、オールドグッチのデザインを復刻させたことで話題となった「オフィディア」。ダブルGマークと定番のキャンパス生地に加え、バッグ中央に施されたシェリーラインがアクセントになったクラシカルな1品。トート、ショルダー、ウエストポーチなど幅広いモデル展開があるので、きっとお好みのアイテムが見つかるはず。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/25.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/26.jpg" alt="" />
          </figure>          
        </div>
        <span className="text-center">GUCCI／オフィディア／24 x20 x10cm</span>  
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/27.jpg" alt="" />
            <span className="text-center">GUCCI／オフィディア／18 x18 x4cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/28.jpg" alt="" />
            <span className="text-center">GUCCI／GGミディアムトートバッグ／37 x27 x13cm</span> 
          </figure>          
        </div>              
        <Link to="https://laxus.co/app/pc/bags/gucci" className="view-all-button">
          グッチのバッグを見る
        </Link>                     
        <div className="text-max-width">
          <h2>グッチシマ</h2>
          <p>「最高級のグッチ」と言う意味を持つグッチシマ。上質なレザーに型押しされたGGモノグラム柄がラグジュアリー感溢れる一品です。ドレススタイルに合わせれば、より一層リッチで優雅なスタイルに仕上げてくれます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/29-1.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/29.jpg" alt="" />
          </figure>          
        </div> 
        <span className="text-center">GUCCI／パドロック／20 x13 x7cm</span>        
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/30.jpg" alt="" />
            <span className="text-center">GUCCI／グッチシマ／36 x22 x9cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/31.jpg" alt="" />
            <span className="text-center">GUCCI／マイクログッチシマ／17 x14 x4cm</span> 
          </figure>
        </div>    
        <div className="text-max-width">
          <h2>GGスプリーム</h2>
          <p>GGスプリームにはセンス光るカラーリングが素敵なものが多数あります♡何にでも合わせやすく、カジュアルスタイルを格上げしてくれる一品です！</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/32.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/33.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">GUCCI／GGスプリーム／28 x22 x10cm</span>        
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/34.jpg" alt="" />
            <span className="text-center">GUCCI／GGスプリーム／17 x10 x3cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/35.jpg" alt="" />
            <span className="text-center">GUCCI／GGスプリーム／37 x28 x11cm</span> 
          </figure>
        </div>                  
        <div className="text-max-width">
          <h2>バンブー</h2>
          <p>バンブーショッパーは持ち手が涼しげで和のテイストがモダンでクールな雰囲気を演出してくれます。また夏に持てばコーデに季節感が出てよりおしゃれさんに見えますよ♪</p>
        </div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/36.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/37.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">GUCCI／バンブーショッパー／20 x17 x8cm</span>            
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/38.jpg" alt="" />
            <span className="text-center">GUCCI／バンブーショッパー／26 x21 x9cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/16/39.jpg" alt="" />
            <span className="text-center">GUCCI／バンブーデイリー／27 x20 x10cm</span> 
          </figure>
        </div>    
        <div className="text-two-cloumn">
          <h2>今グッチから目が離せない！</h2>
          <p>デザイナーの交代で生まれ変わったGUCCI（グッチ）からは、ストリートの空気をまとったパワフルな印象を受けます。<br></br>グッチの大胆なカラーリングや柄のバッグを取り入れれば、スタイリッシュでかっこいい女性に早変わり。デザイナー、アレッサンドロ・ミケーレの独特のセンスが光る新生グッチ。時に奇抜でハードなアイテムは見る人を虜にし、楽しませてくれます。コレクションを発表すれば、瞬く間にセレブやファッショニスタの話題の的となり、グッチがトレンドを牽引していることは言うまでもありません。<br></br>可愛いだけではなく強さを兼ね備えて、レトロなエッセンスを残しつつ、モダンにそして斬新にアップデートされたからこそ、今多くの女性を虜にしているのかもしれませんね♪</p>
        </div>                                      
        <Link to="https://laxus.co/app/pc/bags/gucci" className="view-all-button">
          グッチのバッグを見る
        </Link>                                                   
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post16

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 16}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
